import {Referral} from './referral';
import {Patient} from './patient';
import {Client} from './client';
import {Practitioner} from './practitioner';

export class Research {
  public id: string;
  public number: string;
  public registerDate: Date;
  public status: string;
  public referralDate: Date;
  public caseReportNumber: string;
  public patient: Patient;
  public patientAge: number;
  public surgeryDate: Date;
  public diagnosis: string;
  public client: Client;
  public practitioner: Practitioner;
  public conclusion: string;
  public conclusionDate: Date;
  public modifyDate: Date;
  public modifiedBy: string;

  constructor() {
    this.patient = new Patient();
    this.client = new Client();
    this.practitioner = new Practitioner();
  }
}
